export default "__VITE_ASSET__C7D9bE5W__"